import type { SVGProps } from "react";
export interface PeachIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PeachIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PeachIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.874 6v-.764c0-.886-.468-1.7-1.223-2.146l-.154-.084-.101-.057a1.125 1.125 0 0 1 1-2l.106.045.294.16a4.74 4.74 0 0 1 2.328 4.082V6a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M8.375 11c0-1.514.519-2.782 1.138-3.723a7 7 0 0 1 .394-.54 7.6 7.6 0 0 0-1.39-.112c-.966 0-2.344.457-3.477 1.413-1.104.932-1.915 2.284-1.915 4.062 0 3.932 2.314 6.728 6.26 8.14l.682.251c.628.229 1.139.384 1.934.384 1.059 0 1.614-.276 2.614-.634 3.946-1.413 6.26-4.209 6.26-8.14 0-1.78-.812-3.131-1.915-4.063-1.133-.956-2.512-1.413-3.478-1.413-1.336 0-2.102.217-2.91.672h.001l-.025.015c-.21.12-.71.527-1.155 1.202A4.5 4.5 0 0 0 10.625 11a1.125 1.125 0 0 1-2.25 0m14.75 1.1c0 5.068-3.099 8.593-7.751 10.259-.855.306-1.834.766-3.373.766-1.156 0-1.996-.259-2.705-.517l-.67-.25C3.972 20.694.875 17.169.874 12.1c0-2.544 1.189-4.494 2.714-5.781 1.496-1.263 3.377-1.944 4.928-1.944 1.42 0 2.466.215 3.482.691 1.016-.477 2.064-.691 3.483-.691 1.552 0 3.434.681 4.93 1.944 1.525 1.287 2.713 3.237 2.713 5.781Z"
      />
    </svg>
  );
}
